import { DialogContent, DialogActions } from '@mui/material';
import { ThemeButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';
import { CardsPreviewGroup } from '@shared/ui/parts';
import { useTranslation } from 'react-i18next';
import { useCards } from '@app/api/cards/useCards';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export default function ArchiveCardDialog({ close, data, setTitle }) {
  const { t } = useTranslation();
  const { params } = useSelector((state) => state.cards);
  const isArchiveTab = params?.filter === 'archive';

  const [isLoading, setIsLoading] = useState(false);
  const { archiveCards, unarchiveCards } = useCards();

  useEffect(() => {
    setTitle(isArchiveTab ? 'cards_unarchiving' : 'cards_archiving');
  }, [isArchiveTab]);

  async function onSubmit() {
    setIsLoading(true);
    try {
      const request = isArchiveTab ? unarchiveCards : archiveCards;
      const res = await request({ card_ids: data.map((x) => x.id) });
      if (res) close();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DialogContent>
        <CardsPreviewGroup
          data={data}
          label={
            isArchiveTab
              ? t('are_you_sure_unarchive_cards')
              : t('are_you_sure_archive_cards')
          }
        />
        <br />
        <Note
          type="warning"
          title={t('important')}
          content={
            isArchiveTab ? t('unarchive_card_note') : t('archive_card_note')
          }
        />
      </DialogContent>
      <DialogActions>
        <div className="btns-toolbar">
          <ThemeButton
            startIcon={isArchiveTab ? undefined : 'archive'}
            onClick={onSubmit}
            loading={isLoading}
          >
            {isArchiveTab ? t('unarchive') : t('yes_archive')}
          </ThemeButton>
          <ThemeButton onClick={close} appearance="secondary">
            {t('no_cancel')}
          </ThemeButton>
        </div>
      </DialogActions>
    </>
  );
}
